import { CircularProgress } from '@mui/material';
import { KeycloakError } from 'keycloak-js';
import React, { useEffect, useState } from 'react';
import { RouteProps } from 'react-router';
import * as authService from '../../services/Authentification/authentification';

interface CustomProps {
  children: JSX.Element;
}

type Props = RouteProps & CustomProps;
interface State {
  // Etat du statut d'authentification
  authenticated: boolean;
  // Erreur Keycloak
  error?: KeycloakError;
  unauthorized?: boolean; // Accès non autorisé
  shouldRedirect?: boolean;
}

const PrivateRoute: React.FC<Props> = ({ children }: CustomProps) => {
  const [state, setState] = useState<State>({
    authenticated: false,
    error: undefined as any,
    unauthorized: false,
    shouldRedirect: false,
  });

  useEffect(() => {
    const path = window.location.pathname;

    if (!authService.isAuthenticated()) {
      authService
        .loginIfRequired()
        .then(authenticated => {
          if (authenticated) {
            // Si on n'a pas de statut de souscription et qu'on n'est pas sur l'url de reprise il faut
            // déclencher une reprise de souscription
            if (path !== '/espace-personnel') {
              setState({
                ...state,
                shouldRedirect: true,
              });
            } else {
              setState({
                ...state,
                authenticated: true,
              });
            }
          } else {
            setState({ authenticated });
          }
        })
        .catch(error => {
          setState({
            ...state,
            error,
          });
        });
    }
  }, []);

  const { authenticated, error, shouldRedirect, unauthorized } = state;
  if (error) {
    return <div>Impossible de se connecter !</div>;
  } else if (shouldRedirect) {
    // eslint-disable-next-line no-restricted-globals
    location.href = '/espace-personnel';
    return null;
  } else if (authenticated) {
    if (unauthorized) {
      // eslint-disable-next-line no-restricted-globals
      return null;
    } else {
      // tslint:disable-next-line: jsx-no-lambda
      return children;
    }
  } else {
    return <CircularProgress />;
  }
};

export default PrivateRoute;
